<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>提醒设置</a-breadcrumb-item>
    </a-breadcrumb>
    <a-spin :spinning="loading">
      <div class="notice-box">
        <div class="form-item space-20" v-for="v in configList" :key="v.id">
          <div>
            <span>{{ v.name }}</span>
            <a-input-number @blur="handleSwitchChange(v)" v-model="v.noActionDays" :min="0" class="gap-10" />
            <span>天未跟进提醒</span>
          </div>
          <a-switch v-model="v.switchOn" @change="handleSwitchChange(v)" />
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { noteLists, saveConfig } from '@/api/systemNotices';
export default {
  data() {
    return {
      loading: false,
      configList: []
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await noteLists();
      this.loading = false;
      if (res.code === 200) {
        this.configList = res.data;
      }
    },
    async handleSwitchChange(row) {
      const query = {
        id: row.id,
        noActionDays: row.noActionDays,
        isSwitchOn: row.switchOn
      };
      const res = await saveConfig(query);
      if (res.code === 200 && res.data) {
        this.$message.success(res.data || 'success');
      }
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.notice-box {
  width: 450px;
  margin-left: 50px;
  .form-item {
    display: flex;
    justify-content: space-between;
  }
}
</style>
